navigator.msMaxTouchPoints = undefined;

/**
 * Проверка поддержки на устройстве нажатий
 *
 * @returns {boolean}
 */
function isTouchDevice() {
	return (("ontouchstart" in window)
		|| (navigator.maxTouchPoints > 0)
		|| (navigator.msMaxTouchPoints > 0));
}

/**
 * Удаление hover и фокус из дерева стилей
 *
 * @param {function} func_isTouchDevice
 */
function removeTouchStyles(func_isTouchDevice) {
	if (!func_isTouchDevice()) return;
	const styleSheet = document.styleSheets[0];

	for (let ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
		if (!styleSheet.cssRules[ri].selectorText) continue;

		if (styleSheet.cssRules[ri].selectorText.match(/[:](hover|focus)/g)) {
			styleSheet.deleteRule(ri);
		}
	}
}

removeTouchStyles(isTouchDevice);
